import React, { FC } from "react";
import {RichTextArea} from "../RichTextArea/RichTextArea";
import {SvgIcon} from "../../SvgIcon/SvgIcon";
import classNames from "classnames";

type FAQAccordionItemProps = {
  title: string;
  description: string;
  className?: string;
};

export const FAQAccordionItem: FC<FAQAccordionItemProps> = ({
  title,
  description,
  className
}) => {
  return (
    <details className={classNames(
        "FAQAccordionItem",
        className
    )}>
      <summary className="FAQAccordionItem__btn">
          {title}
          <SvgIcon iconName="chevron-down" className="FAQAccordionItem__icon" />
      </summary>
      <div className="FAQAccordionItem__desc">
        <RichTextArea content={description} small />
      </div>
    </details>
  );
};
